import apiClient from './api';

/**
 * Profile Service
 * Handles profile-related API calls
 */

/**
 * Get user profile
 * @returns {Promise} User profile data
 */
export const getProfile = async () => {
  try {
    // Token will be auto-injected by api interceptor
    const response = await apiClient.post('/ProfileGet.php', {});

    // Save profile data to localStorage
    if (response.data || response.result) {
      const profileData = response.data || response;
      localStorage.setItem('userData', JSON.stringify(profileData));
    }

    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Update user profile
 * @param {Object} profileData - Profile data to update
 * @returns {Promise} Response
 */
export const updateProfile = async (profileData) => {
  try {

    const response = await apiClient.post('/ProfileUpdate.php', profileData);


    // Update localStorage if successful
    if (response.status === 'success') {
      const currentData = JSON.parse(localStorage.getItem('userData') || '{}');
      localStorage.setItem('userData', JSON.stringify({
        ...currentData,
        ...profileData
      }));
    }

    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Get user data from localStorage
 * @returns {Object|null} User data
 */
export const getUserData = () => {
  const userData = localStorage.getItem('userData');
  return userData ? JSON.parse(userData) : null;
};

/**
 * Get user phone number from localStorage
 * @returns {string|null} Phone number
 */
export const getUserPhone = () => {
  return localStorage.getItem('userPhone');
};

/**
 * Save user phone number to localStorage
 * @param {string} phone - Phone number
 */
export const saveUserPhone = (phone) => {
  localStorage.setItem('userPhone', phone);
};
